/**
 * Query string da lista ecommerce — preserva filtro/busca/página ao voltar.
 * @module ecommerceListSearchParams
 */

import {
  DEFAULT_ECOMMERCE_LIST_AUDIENCE,
  isEcommerceListAudience,
  type EcommerceListAudience,
} from "./ecommerceListAudience";
import {
  PATIENT_OP_FILTER_OPTIONS,
  type PatientOpFilter,
} from "./patientListFilters";

export interface EcommerceListSearchState {
  searchTerm: string;
  opFilter: PatientOpFilter;
  audience: EcommerceListAudience;
  page: number;
}

const FILTER_IDS = new Set<PatientOpFilter>(
  PATIENT_OP_FILTER_OPTIONS.map((option) => option.id),
);

function isPatientOpFilter(value: string): value is PatientOpFilter {
  return FILTER_IDS.has(value as PatientOpFilter);
}

export function parseEcommerceListSearch(
  search: string,
): EcommerceListSearchState {
  const params = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search,
  );
  const filterRaw = params.get("filter") || "all";
  const pageRaw = Number(params.get("page"));

  const viewRaw = params.get("view") || "";

  return {
    searchTerm: params.get("q")?.trim() || "",
    opFilter: isPatientOpFilter(filterRaw) ? filterRaw : "all",
    audience: isEcommerceListAudience(viewRaw)
      ? viewRaw
      : DEFAULT_ECOMMERCE_LIST_AUDIENCE,
    page: Number.isInteger(pageRaw) && pageRaw > 0 ? pageRaw : 0,
  };
}

export function serializeEcommerceListSearch(
  state: EcommerceListSearchState,
): string {
  const params = new URLSearchParams();
  if (state.searchTerm.trim()) params.set("q", state.searchTerm.trim());
  if (state.opFilter !== "all") params.set("filter", state.opFilter);
  if (state.audience !== DEFAULT_ECOMMERCE_LIST_AUDIENCE) {
    params.set("view", state.audience);
  }
  if (state.page > 0) params.set("page", String(state.page));
  const serialized = params.toString();
  return serialized ? `?${serialized}` : "";
}
